export var BSE_NSE_EXPIRY_DATES_DATA = "BSE_NSE_EXPIRY_DATES_DATA";
export var BSE_NSE_EXPIRY_DATES_DATA_ERROR = "BSE_NSE_EXPIRY_DATES_DATA_ERROR";
export var BSE_NSE_EXPIRY_DATES_DATA_HIDE_ERROR = "BSE_NSE_EXPIRY_DATES_DATA_HIDE_ERROR";
